import Flex from '@components/Flex/Flex';
import ProfileMenu from '@components/ProfileMenu/ProfileMenu';
import Badge from '@components/Badge/Badge';
import HeaderTitleTile from '@components/HeaderTitleTile/HeaderTitleTile';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import {
  BannerContainer,
  HeaderContainer,
  NotificationsProfileContainer,
} from './Header.styles';
import { HeaderTitleTileProps } from '@components/HeaderTitleTile/HeaderTitleTile.types';
import { User } from '@features/api/response/User';

export interface HeaderProps extends HeaderTitleTileProps {
  banner?: React.ReactNode;
  user?: User;
  smallTitle?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  title,
  subtitles,
  user,
  smallTitle = false,
  banner = false,
}: HeaderProps) => {
  return (
    <HeaderContainer>
      <HeaderTitleTile title={title} subtitles={subtitles} smallTitle={smallTitle}/>
      {banner ? <BannerContainer>{banner}</BannerContainer> : null}
      <NotificationsProfileContainer>
        <Flex
          sx={{
            marginRight: {
              sm: 6,
              md: 16,
            },
            display: 'none',
          }}
        >
          <Badge icon={NotificationsNoneOutlinedIcon} />
        </Flex>
        <ProfileMenu user={user} />
      </NotificationsProfileContainer>
    </HeaderContainer>
  );
};

export default Header;
